import { useSyncExternalStore } from 'react';

// Module-level external store for the profile drawer's open state, so the header
// avatar (mounted per page) and the drawer (mounted once in Root) stay in sync.
let isOpen = false;
let reopenOnNextNavigation = false;
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) {
    listener();
  }
}

export function openProfileDrawer() {
  if (isOpen) {
    return;
  }
  isOpen = true;
  emit();
}

export function closeProfileDrawer() {
  if (!isOpen) {
    return;
  }
  isOpen = false;
  emit();
}

// Called by the /settings redirect so the drawer opens on the tab it lands on
export function reopenProfileDrawerAfterNavigation() {
  reopenOnNextNavigation = true;
}

// Called by the drawer whenever the router location changes: navigation normally
// closes the drawer, except when a reopen was scheduled (the /settings redirect).
export function notifyProfileDrawerNavigation() {
  if (reopenOnNextNavigation) {
    reopenOnNextNavigation = false;
    openProfileDrawer();
    return;
  }
  closeProfileDrawer();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot(): boolean {
  return isOpen;
}

export function useProfileDrawerOpen(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot);
}
